module.exports = __webpack_public_path__ + "static/media/norbertdragonneau.c392bb5e.jpeg";